import {XauditModel} from '../../../models/xaudit.model';
import {TdoChatDataModel} from './tdo-chat-data.model';

export class TdoChatConversationDataModel extends XauditModel {
  ConversationID: string;
  UserID: string;
  ReceiverID: string;
  enumChatReceverTypeID: string;

  dataTDOChats: TdoChatDataModel[];
}
